import {setInteractionId} from '@servicenow/ui-metrics';
import {CONDITIONAL_DISPATCH} from '../symbols';
import {COMPONENT_PROPERTY_CHANGED} from '../constants';
import {get} from '@servicenow/ui-internal';
import getHostVariables from './getHostVariables';

export default function triggerPropertyChangeAction(
	el,
	propertyDetail,
	affectedPropDetail,
	interactionId
) {
	const {propName: name, path} = affectedPropDetail;
	let {previousValue, value} = propertyDetail;
	if (path) {
		previousValue = get(previousValue, path);
		value = get(value, path);
	}
	const hostVariables = getHostVariables(el);
	hostVariables[CONDITIONAL_DISPATCH](
		COMPONENT_PROPERTY_CHANGED,
		{
			name,
			previousValue,
			value,
			host: el
		},
		setInteractionId(
			{
				internal: true
			},
			interactionId
		)
	);
}
